/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { layers } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Loader = styled.div({
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  paddingTop: token('space.800'),
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  pointerEvents: 'none',
  background: token('color.background.neutral.subtle'),
  opacity: 0.5,
  zIndex: layers.card() + 10,
});
